const THL = 'THL';
const OWA = 'OWA';

const getApp = url => {
  if (url.includes('thehumaneleague')) {
    return THL;
  }
  if (url.includes('openwingalliance')) {
    return OWA;
  }
  return false;
};

export const displayForTHL = (url, code) => {
  if (process.env.NODE_ENV === 'test') {
    return code;
  }

  const app = getApp(url);
  if (app === THL || process.env.FEATURE_FLAG === THL) {
    return code;
  }

  return null;
};

export const displayForOWA = (url, code) => {
  if (process.env.NODE_ENV === 'test') {
    return code;
  }

  const app = getApp(url);

  if (app === OWA || process.env.FEATURE_FLAG === OWA) {
    return code;
  }

  return null;
};
